export default __webpack_public_path__ + "images/cf-617adc02abcee400496d073fbbd21515.svg";